//======> Docementation <======//
registerBlockType('tornado/blog-section', {
    title: __('inner Blog Block', 'tornado'),
    description: __(' بلوك صفحة تفاصيل', 'tornado'),
    icon:'feedback',
    category: 'tornado',
    keywords: [ 'tornado', 'section' ],
    supports: {
        align: ['full','wide']
    },
    attributes: {
        section_title : {
            type: 'string',
            selector: '.title',
            default: 'عنوان 1',
        },
     section_title2 : {
            type: 'string',
            selector: '.title2',
            default: 'عنوان 2',
        },
        section_description : {
            type: 'string',
            selector: '.desc1',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        section_description2 : {
            type: 'string',
            selector: '.desc2',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        section_description3 : {
            type: 'string',
            selector: '.desc3',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        section_description4 : {
            type: 'string',
            selector: '.desc4',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        blockquote:{
            type: 'string',
            selector: '.blockquote',
            default: 'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة، لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل هذا النص أو العديد من النصوص الأخرى إضافة إلى زيادة عدد الحروف التى يولدها التطبيق.',
        },
        blockquotespan:{
            type: 'string',
            selector: '.blockquotespan',
            default: 'المصدر:الاسم',
        },
        checklist : {
            type: 'array',
            source: 'children',
            multiline: 'ul',
            selector: '.check-list',
            default: [
                'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
                'لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل',
                'هذا النص هو مثال لنص يمكن أن يستبدل في نفس المساحة',
                'لقد تم توليد هذا النص من مولد النص العربى، حيث يمكنك أن تولد مثل',
            ],
        },
        section_image : {
            type: 'string',
            default: 'http://via.placeholder.com/1400x600',
        },
        description_control : {
            type: 'string',
            default : 'enable',
        },
        description_control2 : {
            type: 'string',
            default : 'disable',
        },
        description_control3 : {
            type: 'string',
            default : 'disable',
        },
        list_control : {
            type: 'string',
            default : 'disable',
        },
        blockquote_control : {
            type: 'string',
            default : 'disable',
        },
        title2_control : {
            type: 'string',
            default : 'disable',
        },
    },
    //==== Editing Mode ====//
    edit: props => {
        //==== Block Data ====//
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        //==== Main ====//
        const set_section_title = section_title => { setAttributes({section_title}) };
        const set_section_title2 = section_title2 => { setAttributes({section_title2}) };
        const set_section_description = section_description => { setAttributes({section_description}) };
        const set_section_description2 = section_description2 => { setAttributes({section_description2}) };
        const set_section_description3 = section_description3 => { setAttributes({section_description3}) };
        const set_section_description4 = section_description4 => { setAttributes({section_description4}) };
        const set_checklist = checklist => { setAttributes({checklist}) };
        const set_description_control = description_control => { setAttributes({description_control}) };
        const set_description_control2 = description_control2 => { setAttributes({description_control2}) };
        const set_description_control3 = description_control3 => { setAttributes({description_control3}) };
        const set_list_control = list_control => { setAttributes({list_control}) };
        const set_blockquote = blockquote => { setAttributes({blockquote}) };
        const set_blockquotespan = blockquotespan => { setAttributes({blockquotespan}) };
        const set_blockquote_control = blockquote_control => { setAttributes({blockquote_control}) };
        const set_title2_control = title2_control => { setAttributes({title2_control}) };
       
        //==== Images and icons Uploader ====//
        const section_image = (openEvent) => {
            return(<img src={ attributes.section_image } alt={ attributes.section_title } onClick={ openEvent }/>)
        };
        //==== Block Structure ====//
        return (
            <Panel>
                <PanelBody>
                    <InspectorControls key="inspector">
                        <PanelBody title={ __('Block Options', 'tornado') }>
                
                            <SelectControl key="description-control" label="اظهار / اخفاء الوصف" value={ attributes.description_control }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_description_control}
                                />
                            <SelectControl key="blockquote_control" label="اظهار / اخفاء blockquote" value={ attributes.blockquote_control }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_blockquote_control}
                            />
                            <SelectControl key="title2_control" label="اظهار / اخفاء العنوان الثاني" value={ attributes.title2_control }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_title2_control}
                            />
                            <SelectControl key="description-control2" label="اظهار / اخفاء الوصف 2" value={ attributes.description_control2 }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_description_control2}
                            />
                            <SelectControl key="list-control" label="اظهار / اخفاء القائمة" value={ attributes.list_control }
                                options={[
                                    { label: 'ظهور', value: 'enable' },
                                    { label: 'اخفاء', value: 'disable' },
                                ]}
                                onChange={set_list_control}
                            />
                            <SelectControl key="description-control3" label="اظهار / اخفاء الوصف 3" value={ attributes.description_control3 }
                                    options={[
                                        { label: 'ظهور', value: 'enable' },
                                        { label: 'اخفاء', value: 'disable' },
                                    ]}
                                    onChange={set_description_control3}
                            />
                             <MediaUpload render={({open}) => section_image(open)} value={ attributes.section_image }  onSelect={media => { setAttributes({section_image: media.url}); }} type="image" />
                        </PanelBody>
                    </InspectorControls>
                    <div className="rich-content">
                        <img src={attributes.section_image} alt={attributes.section_title} className="block-lvl mb30 mt30 round-corner" />  
                        <RichText tagName="h2"  onChange={ set_section_title } value={attributes.section_title} />
                        {attributes.description_control === 'enable' &&
                        <RichText tagName="p" onChange={ set_section_description } value={attributes.section_description}/>}
                        {attributes.description_control === 'enable' &&
                        <RichText tagName="p"  onChange={ set_section_description2 } value={attributes.section_description2}/>}
                        {attributes.blockquote_control === 'enable' &&
                        <RichText tagName="blockquote"  multiline=""  onChange={ set_blockquote } value={ attributes.blockquote } />}
                        {attributes.blockquote_control === 'enable' &&
                        <RichText tagName="span"  onChange={ set_blockquotespan } value={ attributes.blockquotespan } />}
                        {attributes.title2_control === 'enable' &&
                        <RichText tagName="h3"   onChange={ set_section_title2 } value={attributes.section_title2} />}
                        {attributes.description_control2 === 'enable' &&
                        <RichText tagName="p" c  onChange={ set_section_description3 } value={attributes.section_description3}/>}
                        {attributes.list_control === 'enable' &&
                        <RichText tagName="ul" className="half-space squared check-list" multiline="li" placeholder={ __( 'محتوي على شكل قائمة', 'tornado' ) } onChange={ set_checklist } value={ attributes.checklist } />}
                        {attributes.description_control3 === 'enable' &&
                        <RichText tagName="p"   onChange={ set_section_description4 } value={attributes.section_description4}/>}
                
                    </div>            
                </PanelBody>
            </Panel>
        );
    },
    //==== Puplish Mode ====//
    save: props => {
        //==== Block Data ====//
        const { attributes } = props;

        //==== Block Structure ====//
        return (
            <div className="rich-content">
                <img src={attributes.section_image} alt={attributes.section_title} className="block-lvl mb30 mt30 round-corner" />  
                <h2 >{attributes.section_title}</h2>
                {attributes.description_control === 'enable' &&
                <p >{attributes.section_description}</p>}
                {attributes.description_control === 'enable' &&
                <p >{attributes.section_description2}</p>}
                {attributes.blockquote_control === 'enable' &&
                <blockquote className="blockquote" >{attributes.blockquote}<span className="quote-name blockquotespan">{attributes.blockquotespan}</span> </blockquote>}
                {attributes.title2_control === 'enable'  &&
                <h3  >{attributes.section_title2} </h3>}
                {attributes.description_control2 === 'enable' &&
                <p >{attributes.section_description3}</p>}
                {attributes.list_control === 'enable' &&
                <ul className="half-space squared check-list">{ attributes.checklist } </ul>}
                {attributes.description_control3 === 'enable' &&
                <p >{attributes.section_description4}</p>}
            </div>
        );
    },
});